import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { NavigateFunction, useNavigate } from "react-router-dom";
import localStorageConstants from "src/app/constants/localStorage.constants";
import { login } from "src/app/utils/backendEndpointCalls.util";

const LoginScreenViewModel = () => {
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [isLoginLoading, setIsLoginLoading] = useState<boolean>(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState<string>("");
  const [isDisplayingError, setIsDisplayingError] = useState<boolean>(false);
  const [isCheckingToken, setIsCheckingToken] = useState<boolean>(true);

  const navigate: NavigateFunction = useNavigate();

  const togglePasswordVisibility = () => {
    setIsPasswordVisible((previousState: boolean) => !previousState);
  };

  const onLoginPressed = async () => {
    setIsLoginLoading(true);
    const loginResponse = await login(email, password);
    setIsLoginLoading(false);
    if (!loginResponse.success) {
      setIsDisplayingError(true);
      setLoginErrorMessage(loginResponse.error);
      return;
    }
    if (loginResponse.suspended) {
      setIsDisplayingError(true);
      setLoginErrorMessage("Your account is currently suspended.");
      return;
    }
    localStorage.setItem(localStorageConstants.TOKEN, loginResponse.token);
    navigateToHomepage();
  };

  const onEmailFieldChangedEvent = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setEmail(event.target.value);
  };

  const onPasswordFieldChangedEvent = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setPassword(event.target.value);
  };
  const navigateToHomepage = useCallback(() => {
    navigate("/dashboard");
  }, [navigate]);

  useEffect(() => {
    const userToken: string | null = localStorage.getItem(
      localStorageConstants.TOKEN,
    );
    if (!userToken) {
      setIsCheckingToken(false);
      return;
    }
    navigateToHomepage();
  }, [navigateToHomepage]);

  return {
    isPasswordVisible,
    togglePasswordVisibility,
    onEmailFieldChangedEvent,
    onPasswordFieldChangedEvent,
    onLoginPressed,
    isLoginLoading,
    loginErrorMessage,
    isDisplayingError,
    setIsDisplayingError,
    isCheckingToken,
  };
};

export default LoginScreenViewModel;
